import { render, staticRenderFns } from "./LawCounterPartyTypeForm.vue?vue&type=template&id=24ead236&"
import script from "./LawCounterPartyTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawCounterPartyTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawCounterPartyTypeForm.vue?vue&type=style&index=0&id=24ead236&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports